/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Generated bundle index. Do not edit.
 */
export { BrowserModule, platformBrowser, Meta, Title, disableDebugTools, enableDebugTools, BrowserTransferStateModule, TransferState, makeStateKey, By, DOCUMENT, EVENT_MANAGER_PLUGINS, EventManager, HAMMER_GESTURE_CONFIG, HammerGestureConfig, DomSanitizer, VERSION, ɵBROWSER_SANITIZATION_PROVIDERS, ɵINTERNAL_BROWSER_PLATFORM_PROVIDERS, ɵinitDomAdapter, ɵBrowserDomAdapter, ɵBrowserPlatformLocation, ɵTRANSITION_ID, ɵBrowserGetTestability, ɵescapeHtml, ɵELEMENT_PROBE_PROVIDERS, ɵDomAdapter, ɵgetDOM, ɵsetRootDomAdapter, ɵDomRendererFactory2, ɵNAMESPACE_URIS, ɵflattenStyles, ɵshimContentAttribute, ɵshimHostAttribute, ɵDomEventsPlugin, ɵHammerGesturesPlugin, ɵKeyEventsPlugin, ɵDomSharedStylesHost, ɵSharedStylesHost } from "./public_api";
export { _document as ɵb, errorHandler as ɵa } from "./src/browser";
export { GenericBrowserDomAdapter as ɵi } from "./src/browser/generic_browser_adapter";
export { SERVER_TRANSITION_PROVIDERS as ɵg, appInitializerFactory as ɵf } from "./src/browser/server-transition";
export { initTransferState as ɵc } from "./src/browser/transfer_state";
export { _createNgProbe as ɵh } from "./src/dom/debug/ng_probe";
export { EventManagerPlugin as ɵd } from "./src/dom/events/event_manager";
export { DomSanitizerImpl as ɵe } from "./src/security/dom_sanitization_service";
//# sourceMappingURL=platform-browser.js.map


// WEBPACK FOOTER //
// ../../../packages/platform-browser/esm5/platform-browser.js